import { Injectable } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class LayoutService {

    constructor(private breakpointObserver: BreakpointObserver, private router: Router) { }

    initialize(): void {
        this.breakpointObserver.observe([
            Breakpoints.Handset,
            Breakpoints.Tablet
        ]).subscribe(result => {
            const currentRoute = this.router.url;
            if (result.matches) {
                if (!currentRoute.startsWith('/mobile')) {
                    this.router.navigate(['/mobile']);
                }
            } else {
                if (!currentRoute.startsWith('/desktop')) {
                    this.router.navigate(['/desktop']);
                }
            }
        });
    }
}
